/**
 * Instantiates the frontend and binds it to the window.
 */
import Frontend from './frontend';

// bind frontend to window
window.StaticSnapFrontend = new Frontend();
